// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-shapes {
  max-height: 80vh;
  min-height: 300px;
  width: 680px;
  display: flex;
  flex-direction: column;
  height: 560px;
}
.dialog-shapes__title-icon {
  margin-right: 4px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-shapes .g-dialog-body {
  display: flex;
  padding: 0;
  overflow-y: auto;
  height: calc(80vh - 153px);
  border-top: 1px solid var(--g-color-line-generic);
  border-bottom: 1px solid var(--g-color-line-generic);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogShapes/DialogShapes.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;AACI;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAEI;EACI,aAAA;EACA,UAAA;EACA,gBAAA;EACA,0BAAA;EACA,iDAAA;EACA,oDAAA;AAAR","sourcesContent":[".dialog-shapes {\n  max-height: 80vh;\n  min-height: 300px;\n  width: 680px;\n  display: flex;\n  flex-direction: column;\n  height: 560px;\n}\n.dialog-shapes__title-icon {\n  margin-right: 4px;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dialog-shapes .g-dialog-body {\n  display: flex;\n  padding: 0;\n  overflow-y: auto;\n  height: calc(80vh - 153px);\n  border-top: 1px solid var(--g-color-line-generic);\n  border-bottom: 1px solid var(--g-color-line-generic);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
